import rybbit from "@rybbit/js"
import { env } from "configs/EnvironmentConfig"
import posthog from "posthog-js"

import { getTrackingMeta } from "./trackingMeta"

/**
 *  A function to track an analytics event. The event should have a name that
 *  our analytics platform can understand. The data itself should be specific
 *  information about the event. The data will be enriched with current tracking
 *  meta data (like practice slug).
 */
export function trackEvent(eventName: string, data: Record<string, string>) {
  // full event payload
  const payload = {
    ...data,
    practice_slug: getTrackingMeta("practiceSlug"),
  }

  // send the information to posthog, if we have it enabled
  if (env.POSTHOG_KEY) {
    posthog.capture(eventName, payload)
  }

  // send the information to rybbit, if we have it enabled
  if (env.RYBBIT_SITE_ID) {
    rybbit.event(eventName, payload)
  }

  // just for debug purpose and to check when the tracking event would be triggered.
  // console.info("trackEvent", event, payload)
}
